

import { ISummary } from 'src/types/aiForm';
import { IOrgModel } from 'src/types/org/orgInterface';
import { Draft } from 'src/types/common';
import { IDIRecord, IDIRequest, IDIData } from 'src/types/org/di/diInterface';
import { IAddress } from 'src/types';
import { IMsReferenceService, IRegion } from './msReference';
import { parseCode } from 'src/utils/adminUtil';


export interface IDiService {
  mapDiCreate: (data: IDIRequest) => Promise<Draft<IDIRecord>>;
  mapDiUpdate: (data: IDIData) => Promise<Draft<IDIRecord>>;
}

export const DiService = (refService: IMsReferenceService): any => {

  const mapAddress = async (address: Draft<IAddress>) => {
    let region: IRegion | undefined;
    if (address.regionCd) {
      region = await refService.findProvince(address.regionCd);
    }

    if (!region && address.province) {
      region = await refService.findProvince(address?.province);
      address.regionCd = null;
    }

    if (region) {
      address.regionCd = region.key;
      address.province = region.label;
    }
    return address;
  };


  const  mapDiCreate = async (dataRequest: IDIRequest): Promise<Draft<IDIRecord>> => {
    const {
      name,
      visitingAddress,
      email,
      website,
      instLvlCd
    } = dataRequest.data.org;

    const {apAddress} = dataRequest.data.di;

    const nameShort = (name) ? (name.length < 50 ? name : name.slice(0, 50)) : '';
    const nameAbbr = (name) ? (name.length < 30 ? name : name.slice(0, 30)) : '';


    return {
        org: {
            name: name,
            nameShort: nameShort,
            nameAbbr: nameAbbr,
            email: email,
            website: website,
            visitingAddress: await mapAddress(visitingAddress),
            charterInd: false,
            campus: false,
            instLvlCd:instLvlCd,
            phone: {}
        },
        di: {
          ...dataRequest.data.di,
          apAddress: apAddress ? await mapAddress(apAddress) : undefined
        }
    };
  };

  /**
   * Do not add keys when user does not submit those fieldss
   * @param data
   */
  const mapDiUpdate = async (data: IDIData): Promise<Draft<IDIRecord>> => {
    const {
      name,
      visitingAddress,
      email,
      website,
      lowestGradeCd,
      highestGradeCd,
      fax,
      instLvlCd
    } = data.org; // user submission fields

    const {apAddress} = data.di;

    return Promise.resolve({
      org: {
        name,
        visitingAddress: await mapAddress(visitingAddress),
        email,
        phone: {},
        website,
        lowestGradeCd: lowestGradeCd? parseCode(lowestGradeCd) : undefined,
        highestGradeCd: highestGradeCd? parseCode(highestGradeCd): undefined,
        fax: fax?.formatted ? {} : undefined,
        instLvlCd:instLvlCd
      },
      di: {
        ...data.di,
        apAddress: apAddress ? await mapAddress(apAddress) : undefined
      }
    });

    // need to expand these mappers to include a full payload that includes an AI section
    // and need to add support for original records, either retrieving internally here
    // or passing into function, need to evalute use cases
  };


  return {
    mapDiCreate,
    mapDiUpdate
  };
};
